import {ParametrosModel} from "@/models/generales/parametros";
import ParametrosAPI from "@/services/generales/parametros";
import {modelIsModified} from "@/helpers/vue-mc";
import State from '@/helpers/pattern/state';
import {scrollToForm} from '@/helpers/form-scroll-to';

/**
 * State Pattern for Tema form
 */
export default class ParametrosStates extends  State{
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */
  constructor(data){
    super(data)
  }

  /**
   * General Methods
   */
  base(){
    return {
      clear({$setState}){
        $setState('initial');
      }
      , async askForClear({$data}){
        try{
          const response = await $data.$swal({
            title: $data.$t('view.global.swal.clear.title')
            , text: $data.$t('view.global.swal.clear.text')
            , type: $data.$t('view.global.swal.clear.type')
            , showCancelButton: $data.$t('view.global.swal.clear.showCancelButton')
            , confirmButtonColor: $data.$t('view.global.swal.clear.confirmButtonColor')
            , cancelButtonColor: $data.$t('view.global.swal.clear.cancelButtonColor')
            , confirmButtonText: $data.$t('view.global.swal.clear.confirmButtonText')
            , cancelButtonText: $data.$t('view.global.swal.clear.cancelButtonText')
            , reverseButtons: true
          });
          if(response.value){
            this.clear();
          }
          return;
        }catch(error){
          console.log(error)
        }
      }
      , async audit({$data},{clave, tabla, descripcion, revision}){
        try{
          auditoriaStates.EditingState({clave, tabla, descripcion, revision});
        }catch(error){
          console.log(error)
        }
      }
      , resetModel({$data}){
        $data.parametros = new ParametrosModel();
      }
      , resetValidators({$data}){
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({$data}){
        return $data.hasErrors($data.$v.parametros) || $data.view.action.submit.busy;
      }
      
    }
  }

   /**
   * States and its methods
   */
  states(){
    return {
      initial:{
        $constructor:function({$data}){
            //Reset Models and validators
            this.resetModel();
            this.resetValidators();
            //View configuration
            $data.view.elem.button.clear.visible=true;
            $data.view.elem.button.audit.visible=false;
            $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
            $data.view.elem.button.submit.data.title.current = $data.view.elem.button.submit.data.title.save;
            try{
              this.loadParametros($data.parametros.clave)
            }catch(error){
              console.error(error);
            }
        }
        , async submit(
          {$data}
          ,{
            clave 
            , horarioConversionInicio
            , horarioConversionFin
            , horarioDescargaInicio
            , horarioDescargaFin
            , dias
            , summiterID
            , urlBuzonSFTP
            , usuarioBuzonSFTP
            , passwordBuzonSFTP
            , puertoBuzonSFTP
            , seguridadHabilitadaZIP
            , passwordZIP
            , numeroIntentos
          }){
            try{
              if(!$data.isAllValid($data.$v)){
                return false;
              }
              $data.view.action.submit.busy=true;
              const response = await ParametrosAPI.update({clave 
                , horarioConversionInicio
                , horarioConversionFin
                , horarioDescargaInicio
                , horarioDescargaFin
                , dias
                , summiterID
                , urlBuzonSFTP
                , usuarioBuzonSFTP
                , passwordBuzonSFTP
                , puertoBuzonSFTP
                , seguridadHabilitadaZIP
                , passwordZIP
                , numeroIntentos
              });
              $data.view.action.submit.busy=false;
              this.resetModel();
              this.resetValidators();
              return response;
            }catch(error){
              console.log(error)
              return error;
            }
        }
        , async loadParametros({$setState},idParametros){
          try{
            const response = await ParametrosAPI.get({clave:idParametros});
            const {data:{results:{parametros}}} = response;
            $setState('editing',parametros)
            // Object.setPrototypeOf(this.state, new states.EditingState(this,parametros));
          }catch(error){
            console.log(error)
          }
        }
      }
      , editing:{
        $constructor:function({$data}, parametros){
          
          const {clave 
            , horarioConversionInicio
            , horarioConversionFin
            , horarioDescargaInicio
            , horarioDescargaFin
            , dias
            , summiterID
            , urlBuzonSFTP
            , usuarioBuzonSFTP
            , passwordBuzonSFTP
            , puertoBuzonSFTP
            , seguridadHabilitadaZIP
            , passwordZIP
            , numeroIntentos
          } = parametros;
          $data.view.elem.button.clear.visible=true;
          $data.view.elem.button.audit.visible=true;
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.data.title.current = $data.view.elem.button.submit.data.title.update;
          $data.parametros = new ParametrosModel({clave 
            , horarioConversionInicio
            , horarioConversionFin
            , horarioDescargaInicio
            , horarioDescargaFin
            , dias
            , summiterID 
            , urlBuzonSFTP
            , usuarioBuzonSFTP
            , passwordBuzonSFTP
            , puertoBuzonSFTP
            , seguridadHabilitadaZIP
            , passwordZIP
            , numeroIntentos
          });
          this.resetValidators();
        }
        , async submit({$data, $setState}, parametros){
          console.log("Editing: submit");
          let {clave 
            , horarioConversionInicio
            , horarioConversionFin
            , horarioDescargaInicio
            , horarioDescargaFin
            , dias
            , summiterID
            , urlBuzonSFTP
            , usuarioBuzonSFTP
            , passwordBuzonSFTP
            , puertoBuzonSFTP
            , seguridadHabilitadaZIP
            , passwordZIP
            , numeroIntentos
          }=parametros;
          try{
            if(!$data.isAllValid($data.$v)){
              scrollToForm($data);
              $data.view.messageError ='Por favor, valide los campos obligatorios'
              return false;
            }
            $data.view.action.submit.busy=true;
            if(!seguridadHabilitadaZIP)
              passwordZIP = null;
            
            const response = await ParametrosAPI.update({clave 
              , horarioConversionInicio
              , horarioConversionFin
              , horarioDescargaInicio
              , horarioDescargaFin
              , dias
              , summiterID
              , urlBuzonSFTP
              , usuarioBuzonSFTP
              , passwordBuzonSFTP
              , puertoBuzonSFTP
              , seguridadHabilitadaZIP
              , passwordZIP
              , numeroIntentos
            });
            $data.view.action.submit.busy=false;
            $setState('initial')
            return response;
          }catch(error){
            console.log(error)
            return error;
          }
        }
        , isDisableButtonSubmit({$data}){
          return $data.hasErrors($data.$v.parametros) 
            || $data.view.action.submit.busy
            || !modelIsModified($data.parametros)
        }
      }
    }
  }

}






// WEBPACK FOOTER //
// ./src/views/generales/parametros/parametros-states.js